export default {
  activities: [],
  activitiesLoading: true,
  openPanels: [],
  activitiesByEntity: []
}
